import { render, staticRenderFns } from "./VATPercentsUsed.vue?vue&type=template&id=2714d552&scoped=true"
import script from "./VATPercentsUsed.vue?vue&type=script&lang=ts"
export * from "./VATPercentsUsed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714d552",
  null
  
)

export default component.exports